(function urlHandler(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.FullImageViewer = global.NewHomeSource.FullImageViewer || {};
  const previousUrlHandler = global.NewHomeSource.FullImageViewer.UrlHandler;

  /**
   * @constructs NewHomeSource.UrlHandler
   */
  function UrlHandler() {
  }

  /**
  * @public
  * insertQueryString: inserts additional parameters to the url.
  *
  * @param {string} url where the query string is going to be added.
  * @param {string} queryString to add to the string.
  */
  UrlHandler.insertQueryString = function insertQueryString(url, queryString) {
    let firstQuestion = url.indexOf('?') + 1;
    let queryStringToAppend = queryString;

    if (!queryString) {
      queryStringToAppend = '';

      if (firstQuestion > 0) {
        firstQuestion -= 1;
      } else if (firstQuestion === 0) {
        firstQuestion = url.length;
      }
    }

    if (queryString && firstQuestion === 0) {
      queryStringToAppend = '?' + queryString;
      firstQuestion = url.length;
    }

    return url.substring(0, firstQuestion) + queryStringToAppend;
  };

  /**
   * @public
   * removeQueryString: returns the given URL without the querystring portion.
   *
   * @param {string} url where the query string is going to be removed.
   */
  UrlHandler.removeQueryString = function removeQueryString(url) {
    const position = url.indexOf('?');

    if (position < 1) {
      return url;
    }

    return url.substring(0, position);
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.FullImageViewer.UrlHandler to the previous script.
   */
  UrlHandler.noConflict = function noConflict() {
    global.NewHomeSource.FullImageViewer.UrlHandler = previousUrlHandler;
    return UrlHandler;
  };

  global.NewHomeSource.FullImageViewer.UrlHandler = UrlHandler;
}(window));
